/* ============================================================================
   /join?c=<access-code> — a one-tap invite landing. The contractor, client,
   bidder or team member follows the link from their WhatsApp/email invite and
   is signed in and dropped straight into their room — NOT the two-module
   selector (which also offered the Bid Manager they can't open). Falls back to
   the Welcome sign-in, with the code carried across, if the code doesn't take.
   ========================================================================== */
import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Icon } from "./components/Icons";
import { STUDIO } from "./lib/store";
import { loginWithCode, homeFor } from "./lib/auth";

export default function Join() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const code = (params.get("c") ?? params.get("code") ?? "").trim();
  const [state, setState] = useState<"working" | "failed">("working");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      if (!code) { setState("failed"); return; }
      const s = await loginWithCode(code);
      const tab = (params.get("tab") ?? "").trim();
      if (s) nav(homeFor(s) + (tab ? `?tab=${encodeURIComponent(tab)}` : ""), { replace: true });
      else setState("failed");
    })();
  }, [code, nav, params]);


  return (
    <div style={{ minHeight: "100vh", background: "var(--paper)", display: "grid", placeItems: "center", padding: 24 }}>
      <div className="card" style={{ padding: 30, maxWidth: 420, width: "100%", textAlign: "center" }}>
        <div style={{ width: 44, height: 44, borderRadius: 12, background: "var(--ink)", color: "var(--paper)", display: "grid", placeItems: "center", margin: "0 auto" }}>
          <Icon.logo width={24} />
        </div>
        {state === "working" ? (
          <>
            <div className="serif" style={{ fontSize: 22, marginTop: 18 }}>Opening your project…</div>
            <p className="muted" style={{ fontSize: 13.5, marginTop: 8 }}>Signing you in to {STUDIO.name} {STUDIO.unit} with your invite.</p>
            <div className="dim" style={{ fontSize: 12, marginTop: 16 }}>One moment.</div>
          </>
        ) : (
          <>
            <div className="serif" style={{ fontSize: 22, marginTop: 18 }}>We couldn't open that invite</div>
            <p className="muted" style={{ fontSize: 13.5, marginTop: 8 }}>
              {code
                ? <>The code <b className="mono">{code}</b> didn't match a room. It may have been changed — check the latest invitation, or sign in manually.</>
                : <>This link is missing its access code. Open it again from your invitation, or sign in manually.</>}
            </p>
            <button className="btn accent" style={{ marginTop: 18 }} onClick={() => nav(code ? `/?code=${encodeURIComponent(code)}` : "/")}>
              <Icon.arrow width={15} />Go to sign in
            </button>
          </>
        )}
      </div>
    </div>
  );
}
